import { Button, Image, Input, Spin } from "antd";
import { LoadingOutlined } from '@ant-design/icons';
import { memo, useEffect, useRef, useState } from "react"
import styled from "styled-components";
import { UI_Header, UI_HeaderLeft, UI_HeaderRight, UI_HeaderRight_item } from "../PanelStyle";
import { useAtom, useAtomValue } from 'jotai';
import { showChatSamPanelAtom } from "../../stores/mapStore";
import { FaXmark, FaCamera } from "react-icons/fa6";
import { PiRobotBold } from "react-icons/pi";
import { IoEllipsisHorizontal } from "react-icons/io5";
import axios from "axios";
import FormItemWrapper from "~/components/common/FormItemWrapper/FormItemWrapper";

/**
 * 
 */
export const ChatSamPanel = () => {
  const [showChatSamPanel, setShowChatSamPanel] = useAtom(showChatSamPanelAtom);
  const [screenshot, setScreenshot] = useState<string | null>(null);
  const [isCapturing, setIsCapturing] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [label, setLabel] = useState('');

  const getCaptureScreenshot = async () => {
    let count = 0;
    while (true) {
      count += 1;
      if (count > 10) {
        return undefined;
      }
      const screenshot = await tryCaptureScreenshot();
      if (screenshot && screenshot.length > 50000) {
        setScreenshot(screenshot);
        return screenshot;
      }

      await new Promise((resolve) => setTimeout(() => resolve(''), 100));
    }
  }

  const tryCaptureScreenshot = async () => {
    if (!window.map) return;
    const map = window.map!;
    map.triggerRepaint();

    try {
      // Wait for the map to be fully loaded and rendered
      await new Promise(resolve => {
        if (map.loaded()) {
          // If map is already loaded, wait for the next frame
          requestAnimationFrame(resolve);
        } else {
          // If not loaded yet, wait for the load event
          map.once('render', () => requestAnimationFrame(resolve));
        }
      });

      // Create a new canvas with the same dimensions as the map
      const mapCanvas = map.getCanvas();
      const canvas = document.createElement('canvas');
      canvas.width = mapCanvas.width;
      canvas.height = mapCanvas.height;

      // Get the 2D context and draw the map
      const ctx = canvas.getContext('2d');
      if (!ctx) throw new Error('Could not get canvas context');

      // Draw the map canvas onto our new canvas
      ctx.drawImage(mapCanvas, 0, 0);

      // Convert to data URL and update state
      const dataUrl = canvas.toDataURL('image/png');
      // setScreenshot(dataUrl);
      return dataUrl;
    } catch (error) {
      console.error('Error capturing map screenshot:', error);
      throw error; // Re-throw to handle in the calling function
    }
  };

  const onClickStart = async () => {
    if (!window.map) {
      console.error('Map not initialized or no screenshot available');
      return [];
    }

    try {
      const screenshotBase64 = await getCaptureScreenshot();
      const response = await axios.post('https://sam.geodrone.tlgeo.net/sam-text', {
        labels: label,
        image: screenshotBase64,
      });

      const detections = response.data.detection_result;

      if (!Array.isArray(detections)) {
        console.error('Invalid polygon data received');
        return [];
      }

      // Function to convert screen coordinates to map coordinates
      const convertScreenToMapCoords = (screenCoords: number[][]): number[][] => {
        if (!window.map) return [];
        return screenCoords.map(point => {
          // Convert screen coordinates to map coordinates (lng, lat)
          const lngLat = window.map?.unproject([point[0], point[1]]);
          return [lngLat?.lng, lngLat?.lat];
        });
      };

      // Convert all polygons from screen to map coordinates
      const mapPolygons = detections.map((detection: any) => {
        const polygons = detection.polygon;
        if (!Array.isArray(polygons) || polygons.length === 0) return [];

        // Handle both single polygon and multipolygon formats
        if (Array.isArray(polygons[0][0])) {
          // Multipolygon format
          return polygons.map((ring: number[][]) => convertScreenToMapCoords(ring));
        } else {
          // Single polygon format
          return convertScreenToMapCoords(polygons);
        }
      });

      console.log('Converted map coordinates:', mapPolygons);
      const features = mapPolygons.map((polygon: number[][] | number[][][]) => {
        return {
          type: 'Feature',
          properties: {},
          geometry: {
            type: 'Polygon',
            coordinates: polygon[0][0] instanceof Array ? polygon : [polygon],
          },
        };
      });
      // const responsePoints: number[][] = mapPolygons[0] as number[][];
      // const geojsonPolygon = [...responsePoints, responsePoints[0]];

      // Add polygon as source, and add layer to map
      {
        const sourceId = 'polygon-chat-sam-source';
        const layerId = 'polygon-chat-sam-layer';
        const geojsonData = {
          type: 'FeatureCollection',
          features: features,
        };
        console.log('geojsonData', geojsonData);
        window.map?.addSource(sourceId, {
          type: 'geojson',
          data: geojsonData,
        });
        window.map?.addLayer({
          id: `${layerId}-fill`,
          type: 'fill',
          source: sourceId,
          paint: {
            'fill-color': '#ff0000',
            'fill-opacity': 0.2,
          },
        });
        window.map?.addLayer({
          id: `${layerId}-line`,
          type: 'line',
          source: sourceId,
          paint: {
            'line-color': '#ff0000',
            'line-width': 1,
          },
        });
      }

    } catch (error) {
      console.error('Error processing polygons:', error);
    } finally {
      setIsProcessing(false);
    }
  };


  return <UI_Wrapper>
    {/* Header */}
    <UI_Header>
      <UI_HeaderLeft style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <PiRobotBold style={{ color: '#2563eb', fontSize: '18px' }} />
        <span>Tự động khoanh vùng bằng nhãn</span>
      </UI_HeaderLeft>
      <UI_HeaderRight>
        <UI_HeaderRight_item onClick={() => {
          setShowChatSamPanel(false);
        }}>
          <FaXmark />
        </UI_HeaderRight_item>
      </UI_HeaderRight>


    </UI_Header>
    {/* End Header */}
    {/* Toolbar */}
    <UI_Toolbar>
      {/* Left toolbar */}
      <UI_Toolbar_Left>
      </UI_Toolbar_Left>
      {/* End left toolbar */}

      {/* Right Toolbar */}
      <UI_Toolbar_Right>
        <UI_ToolbarItem>
          <IoEllipsisHorizontal />
        </UI_ToolbarItem>
      </UI_Toolbar_Right>
      {/* End right toolbar */}
    </UI_Toolbar>
    {/* End Toolbar */}
    {/* Content */}

    <UI_Content>
      <FormItemWrapper label="Nhãn đối tượng khoanh vùng (In english)">
        <Input value={label} onChange={(e) => {
          setLabel(e.target.value);
        }} />
      </FormItemWrapper>
      <Button loading={isProcessing} onClick={() => {
        onClickStart();
      }}>Bắt đầu</Button>
      {screenshot && <img style={{ width: '100%' }} src={screenshot} />}
    </UI_Content>
  </UI_Wrapper>
}

export default memo(ChatSamPanel);

const UI_Wrapper = styled.div`
  width: 300px;
  height: 500px;
  position: absolute;
  top: 16px;
  right: 16px;
  background-color: white;
  border-radius: 8px;
  background-color: rgba(255,255,255, 0.8);
  backdrop-filter: blur(10px);
  box-shadow: var(--shadows-paneShadow);
`;

const UI_Content = styled.div`
  padding: 16px;
  height: calc(100% - 96px);
  overflow: auto;
`

const UI_Toolbar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

const UI_ToolbarItem = styled.div`
  cursor: pointer;
  padding: 4px;
`

const UI_Toolbar_Left = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`

const UI_Toolbar_Right = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`

const UI_ScreenshotContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 4px;
  min-height: 200px;
`

const UI_Placeholder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #999;
  text-align: center;
  padding: 16px;
  height: 100%;
  width: 100%;
`